import { forwardRef } from 'react'

import { Separator as SeparatorPrimitive } from '@base-ui/react/separator'

import { cn } from '../../../utils/cn'

export type DividerProps = Omit<
  React.ComponentPropsWithRef<typeof SeparatorPrimitive>,
  'orientation'
>

/**
 * Horizontal section divider. The white line under the grey one is
 * intentional: it fakes an engraved edge (depth), so the divider only reads
 * correctly on a surface darker than white, such as `bg-background`.
 */
export const Divider = forwardRef<HTMLDivElement, DividerProps>(
  ({ className, ...props }, ref) => (
    <SeparatorPrimitive
      ref={ref}
      data-slot='divider'
      className={cn(
        'border-t-surface-300 border-b-surface h-0 w-full border-y',
        className
      )}
      {...props}
    />
  )
)
Divider.displayName = 'Divider'
